import { RevenueCodeType } from '../typesFinancial';
import { getHeaders, tosApi } from './tosApi';

export const revenueCodeApi = tosApi.injectEndpoints({
  endpoints: (build) => ({
    getRevenueCodes: build.query<RevenueCodeType[], void>({
      query: () => ({
        url: '/financial/revenue-codes',
        method: 'GET',
        headers: getHeaders,
      }),
      transformResponse: (response: RevenueCodeType[]) =>
        response.map((revenueCode) => ({
          ...revenueCode,
          name: `${revenueCode.code} - ${revenueCode.description}`,
        })),
      keepUnusedDataFor: 300,
    }),
  }),
  overrideExisting: true,
});

export const { useGetRevenueCodesQuery } = revenueCodeApi;
